module.exports = require("./kw.d.ts");